<template>

  <div style="width: 100%;height:100%">
    <div class="edit-location">
      <div class="edit-location-form form">
<!--         <div class="close-modal">
          <button type="button" class="close" aria-label="Close" v-on:click="closeEdit">
            <span aria-hidden="true" style="font-size:2em" class="align-middle">&times;</span>
            <span class="align-middle">close</span>
          </button>
        </div> -->
        <div class="edit-location-content">
        <div v-if="batchEdition"> <strong><h4>Editing {{selectedEntities.length}} items</h4></strong></div>

            <div class="row">
                <div class="col-md-12" >
                   <div v-if="batchEdition" class="pull-left mb-4">
                      <select class="form-control" style="min-width: 200px;">
                        <option v-for="item in selectedEntities">{{item.id}} - {{item.address.streetAddress}}, {{item.address.addressLocality}}, {{item.address.addressRegion}} {{item.address.postalCode}}</option>
                      </select>
                   </div>

                  <div class="pull-right mb-4">
                    <button class="btn btn-danger" v-on:click="closeEdit">Cancel</button>
                    <button v-if="!dynShowPublishingAlert" class="btn btn-primary btn-md ml-4 b-4" v-on:click="saveDataLocalBusiness" :disabled="batchEdition && !batchButtonEnabled">
                      <span v-if="batchEdition">Update {{selectedEntities.length}} items</span>
                      <span v-if="newEntity">Save New Location</span>
                      <span v-if="!newEntity && !batchEdition">Save Location Updates</span>
                   </button>
                    <button v-if="dynShowPublishingAlert" class="btn btn-primary btn-md ml-4 b-4 btn-outline-primary disabled">
                      <span v-if="batchEdition">Update {{selectedEntities.length}} items</span>
                      <span v-if="newEntity">Save New Location</span>
                      <span v-if="!newEntity && !batchEdition">Save Location Updates</span>
                   </button>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header">
                  <strong>Location Details</strong>
                </div>
                <div class="card-body edit-location-address-info">
                  <div class="row">

                      <div class="col-md-6">
                        <text-input
                          :validationRule="validationRuleForLocalBusinessField('name')"
                         v-if="isLocalBusinessFieldVisible('name')"
                         inputId="name"
                         v-model="editLocalBusiness.name"
                         label="Name"  />
                      </div>


                      <div class="col-md-6">
                        <text-input
                          validationRule="required|branchcode"
                         v-if="isLocalBusinessFieldVisible('branchCode')"
                         inputId="branchCode"
                         v-model="editLocalBusiness.branchCode"
                         label="Store code"  />
                      </div>


                      <div class="col-md-6">
                        <text-input
                         v-if="isLocalBusinessFieldVisible('description')"
                         inputId="description"
                         v-model="editLocalBusiness.description"
                         label="Description"  />
                      </div>


                      <div class="col-md-6">
                        <fax-number-input
                        :validationRule="validationRuleForLocalBusinessField('telephone')"
                        v-if="isLocalBusinessFieldVisible('telephone')"
                        inputId="telephone"
                        v-model="editLocalBusiness.telephone"
                        label="Phone" />
                      </div>


                      <div class="col-md-12">
                        <postal-address
                          v-if="isLocalBusinessFieldVisible('address')"
                            :addressRegion.sync="editLocalBusiness.address.addressRegion"
                            :addressLocality.sync="editLocalBusiness.address.addressLocality"
                            :streetAddress.sync="editLocalBusiness.address.streetAddress"
                            :postalCode.sync="editLocalBusiness.address.postalCode"
                            :addressCountry.sync="editLocalBusiness.address.addressCountry"
                            :street2.sync="editLocalBusiness.additionalProperty"
                            :showLatLong="true"
                            :longitude.sync="editLocalBusiness.geo.longitude"
                            :latitude.sync="editLocalBusiness.geo.latitude"
                        >
                        </postal-address>
                      </div>






                  </div>
                </div>
              </div>
              <!-- Properties Blocks -->
                <div class="card" v-if="isLocalBusinessFieldVisible('additionalProperty')" >
                  <div class="card-header">
                    <strong>Additional Properties</strong>
                  </div>
                  <div class="card-body ">
                    <additional-props inputId="additionalProperty" label="Advanced Information" v-model="editLocalBusiness.additionalProperty" :valid-props="getAddPropsSpec()"></additional-props>
                  </div>
                </div>

                <div class="card" >
                  <div class="card-header">
                    <strong>Images</strong>
                  </div>
                  <div class="card-body" style="padding: 20px">
                    <div class="row">

                  <div class="col-md-6">
                    <remote-image
                    v-if="isLocalBusinessFieldVisible('logo')"
                    inputId="logo"
                    v-model="editLocalBusiness.logo" label="Logo"></remote-image>
                  </div>
                  <div class="col-md-6">
                    <remote-image
                    v-if="isLocalBusinessFieldVisible('photo')"
                    inputId="photo"
                    v-model="editLocalBusiness.photo" label="Photo"></remote-image>
                  </div>
                    </div>
                   </div>
                </div>
                <div class="card">
                  <div class="card-header">
                    <strong>Store Hours</strong>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-12">
                           <runtime-hours
                           v-if="isLocalBusinessFieldVisible('openingHoursSpecification')"
                           inputId="openingHoursSpecification"
                            label="Store Hours"
                            data-vv-name="openingHoursSpecification"
                            v-model="editLocalBusiness.openingHoursSpecification"
                            :showDayOfWeek="true"
                            :showAllDaysOfWeek="true"
                            :showToggleDay="batchEdition"
                            v-on:daytoggle="toggleBatchDay"
                            :showPopulateMatchesButton="batchEdition"
                            ></runtime-hours>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">
                    <strong>Holiday Hours</strong>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-12">
                           <runtime-hours
                           v-if="isLocalBusinessFieldVisible('specialOpeningHoursSpecification')"
                           inputId="specialOpeningHoursSpecification"
                            label="Holiday Hours"
                            data-vv-name="specialOpeningHoursSpecification"
                            v-model="editLocalBusiness.specialOpeningHoursSpecification"
                            :showValidFrom="true"
                            :showDescription="true"
                            :showBatchClearSwitch="batchEdition"
                            :batch-location-count="this.selectedEntities.length"
                            :showPopulateMatchesButton="batchEdition"
                            ></runtime-hours>
                      </div>
                    </div>
                  </div>
                </div>


      </div>
    </div>
  </div>
  <modal title="Modal title" class="modal-danger" v-model="confirmModal" @ok="saveBatchEditFieldsPromise" effect="fade/zoom">
    <div slot="modal-header" class="modal-header">
      <h4 class="modal-title">Are you sure you want to update these {{this.selectedEntities.length}} Locations?</h4>
    </div>
    The following fields will be updated:
    <ul>
    <li v-bind:key="item" v-for="item in batchEditFieldsApplied">
       {{item}}
    </li>
    </ul>
    This cannot be undone.
    <div class="progress" v-if="this.showProgress">    
    <progressbar :now="this.progress" label type="primary" striped animated></progressbar>
   </div>
  </modal>
  <alert :show.sync="dynShowPublishingAlert" v-model="dynShowPublishingAlert" placement="top" number="0" type="danger" width="380px" dismissable style="margin-top: 20px;">
    <span class="icon-info-circled alert-icon-float-left"></span>
    <strong></strong>
    <p>Location editing is disabled during Publishing</p>
  </alert>
 </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import { db } from '../../firebase'
import { dropdown, alert } from "vue-strap";
import modal from "vue-strap/src/Modal";
import progressbar from "vue-strap/src/Progressbar"
// dynamic imports
import AdditionalProp from './widgets/additional-props.vue'
import PostalAddress from './widgets/postal-address.vue'
import TextInput from './widgets/text-input.vue'
import RemoteImage from './widgets/remote-image.vue'
import StoreHours from './widgets/runtime-hours.vue'
import RunTimeHours from './widgets/runtime-hours.vue'
import FaxOrPhoneNumberInput from './widgets/fax-number-input.vue'
import DateInput from './widgets/date-input.vue'
import BusinessFunctionCombo from 'vue-select'
import DurationTime from './widgets/runtime-hours.vue'
import PlaceComponent from './widgets/place-input.vue'
import VueWorker from 'vue-worker'
Vue.use(VueWorker)
Vue.use(VeeValidate, { fastExit: false })


export default {
  props: {
    selectedEntities: { type: Array, default: function () { return [] } }
  },
  data: function () {
    return {
      editLocalBusiness: {"@context":"http://schema.org/","@type":"LocalBusiness","additionalProperty":[],"address":{"@type":"PostalAddress","addressCountry":"","addressRegion":"","postOfficeBoxNumber":"","postalCode":"","addressLocality":"","streetAddress":"","faxNumber":"","contactType":"","email":"","telephone":"","name":"","description":"","disambiguatingDescription":"","alternateName":""},"branchCode":"","description":"","geo":{"@type":"GeoCoordinates","latitude":"","longitude":"","addressCountry":"","elevation":"","postalCode":"","name":"","description":"","disambiguatingDescription":"","alternateName":""},"logo":"","name":"","openingHoursSpecification":[],"photo":"","specialOpeningHoursSpecification":[],"telephone":""},
    batchEditionFields: ["name", "photo", "logo", "openingHoursSpecification", "specialOpeningHoursSpecification", "description", "additionalProperty"],
      newEntity: true,
      batchEdition: false,
      hasBranchCode: false,
      childValidations:[],
      batchEditFields:{},
      batchEditDays:[],
      shouldClearAllHolidays: false,
      confirmModal: false,
      batchEditFieldsApplied: [],
      showProgress: false,
      progress: 0,
      showPublishingAlert: true
    }
  },
  components: {
    'additional-props': AdditionalProp,
    'postal-address': PostalAddress,
    'text-input': TextInput,
    'remote-image': RemoteImage,
    'runtime-hours': StoreHours,
    'runtime-hours': RunTimeHours,
    'fax-number-input': FaxOrPhoneNumberInput,
    'date-input': DateInput,
    'vue-select': BusinessFunctionCombo,
    'runtime-hours': DurationTime,
    'place-input': PlaceComponent
    ,
    'dropdown' : dropdown,
    'modal' : modal,
    'progressbar' : progressbar,
    'alert' : alert
  },
  // mixins: [datemixin, geomixin],
  created: function () {
    const self = this
    //register for child validation interceptors
    this.$on('child-validation', function(validationFunc) {
      if (this.childValidations.indexOf(validationFunc) == -1) {
         this.childValidations.push(validationFunc)
      }
    })
    console.log(this.$store.getters.isPublishingData('pages'))

    console.log('callled created')
    console.log('init sel entity')
    console.log(this.selectedEntities)

    this.batchEdition = this.selectedEntities.length > 0
    if (this.batchEdition) {
      this.newEntity = false
      this.$on('populate-matches', this.loadMatchedHours)
      this.$on('clear-all-holidays', this.clearAllHolidays)
    }



    // To be sure the main list will be loaded case come diretly to edition using deep link or full refresh
    this.$store.dispatch('fetchDatabase', { firebaseNode: 'LocalBusinesses',  onFetchResult: (results) => {} })

    this.hasBranchCode = true
    let currentOrg = this.$route.params.organization
    Validator.extend('branchcode', {
      getMessage: function (field, params, data) {
        return (data && data.message) || 'A store with this name already exists'
      },
      validate: function (value) {
        return new Promise(resolve => {
          db.ref('/LocalBusinesses/' + self.$route.params.organization).once('value', snapshot => {
            // console.log(snapshot.hasChild(self.editData.branchCode))
            if (!self.newEntity && !isEmpty(self.editLocalBusiness.branchCode)) {
              resolve({
                valid: true,
                data: ''
              })
            } else if (!self.editLocalBusiness.branchCode) {
              resolve({
                valid: false,
                data: ''
              })
            } else {
              resolve({
                valid: !snapshot.hasChild(self.editLocalBusiness.branchCode),
                data: ''
              })
            }
          })
        })
      }
    })

     const dictionary = {
      en: {
        messages: {
          streetAddress: () => 'Street Address is required'
        },
        attributes: {
          'streetAddress': 'street address',
          'storeID': 'store id',
          'postalCode': 'ZIP code',
          'phone': 'phone',
          'name': 'Name',
          'branchCode': 'Store code',
          'description': 'Description',
          'telephone': 'Phone',
          'address': 'Address',
          'additionalProperty': 'Advanced Information',
          'logo': 'Logo',
          'photo': 'Photo',
          'openingHoursSpecification': 'Store Hours',
          'specialOpeningHoursSpecification': 'Holiday Hours'
        }
      }
    }
    this.$validator.updateDictionary(dictionary)
  },
  updated: function () {
  },
  methods: {
    testWorker: function() {
      console.log("called test worker")
    },
    loadMatchedHours(inputId) {
      let compList = this.editLocalBusiness[inputId]
      let matchesMap = {}
      let matchesList = []
      let countTotal = 0
      if (compList) {
        _.each(this.selectedEntities, entity => {
           let hours = entity[inputId]
           _.each(hours, h => {
              let _id = JSON.stringify(h)
              countTotal++
              if (matchesMap[_id] == null) {
                 matchesMap[_id] = h
                 matchesList.push(h)
              }
           })
         })

        matchesList.sort(function(a, b) {
          let validFromA = a["validFrom"]
          let opensA = a["opens"]
          let closesA = a["closes"]
          let dayOfWeekA = a["dayOfWeek"]
          let validFromB = b["validFrom"]
          let opensB = b["opens"]
          let closesB = b["closes"]
          let dayOfWeekB = b["dayOfWeek"]
          let sortStringA = ""
          let sortStringB = ""

          if (dayOfWeekA != null && dayOfWeekA.length > 0){
            dayOfWeekA = dayOfWeekA.replace("http://schema.org/", "")
            dayOfWeekB = dayOfWeekB.replace("http://schema.org/", "")

            let weekDays = {"Sunday": "1", "Monday": "2", "Tuesday": "3", "Wednesday": "4", "Thursday": "5", "Friday": "6", "Saturday": "7" }

            sortStringA = weekDays[dayOfWeekA] + "-" + opensA + "-" + closesA
            sortStringB = weekDays[dayOfWeekB] + "-" + opensB  + "-" + closesB
          } else if (validFromA) {
            sortStringA = validFromA + "-" + opensA + "-" + closesA
            sortStringB = validFromB + "-" + opensB + "-" + closesB
          } else {
            sortStringA = ""
            sortStringB = ""
          }
          if (sortStringA > sortStringB ) {
            return 1
          } else if (sortStringA < sortStringB ) {
            return -1
          }
          return 0

        })

        this.editLocalBusiness[inputId] = matchesList
        console.log('loadMatchedHours: Common:' + Object.keys(matchesList).length +' Original: ' + countTotal)
        console.log(matchesList)
      }
    },
    clearAllHolidays: function (event) {
      this.shouldClearAllHolidays = event
    },
    validationRuleForLocalBusinessField(key) {

      if (key === 'faxNumber' || key === 'alternateName') {
        return ''
      }

      if (this.batchEdition) {
        return ''
      }

      return 'required'

    },
    isLocalBusinessFieldVisible : function (fieldKey){

      if (fieldKey == "additionalProperty" && !this.$store.getters.organization._additionalPropertiesSpec) {
          return false
      }

      if (this.batchEdition) {
        return this.batchEditionFields.includes(fieldKey)
      }

      return true
    },
    saveDataLocalBusiness: function () {

       this.$validator.validateAll().then((result) => {
        if (result) {
          // check child validations
          let ok = true
          if (this.childValidations) {
            for (let i = 0; i < this.childValidations.length; i++) {
              if (!this.childValidations[i]()) {
                ok = false
              }
            }
          }
          if (!ok) {
            alert('Error saving the new Location.  Check the form for errors.')
            return
          }
          if (this.batchEdition) {
            this.checkSaveBatchEditFields()
            return
          }
          var newObj = _.clone(this.editLocalBusiness, true);
          console.log('saveLocalBusiness')
          console.log(newObj)
          let objId = null
          let saving = false
          if (newObj['.key']) {
            objId = newObj['.key']
            delete newObj['.key']
            this.$store.commit('setSavingId', objId)
            this.$firebaseRefs.fbLocalBusiness.ref.set(newObj)
          } else {
            if (this.newEntity) {
              if (!isEmpty(this.editLocalBusiness["branchCode"])) {
                objId = this.editLocalBusiness["branchCode"]
                this.$store.commit('setSavingId', objId)
                this.$firebaseRefs.fbLocalBusinessOrg.child(objId).set(newObj)

              } else {
                let newRef = this.$firebaseRefs.fbLocalBusinessOrg.push(newObj)
                objId = newRef.key
              }
            } else {
              objId = this.$route.params.entityId
              this.$store.commit('setSavingId', objId)
              this.$firebaseRefs.fbLocalBusinessOrg.child(objId).set(newObj)
            }
          }
          newObj.id = objId
          // this.$store.commit('appendItems', {firebaseNode: 'LocalBusinesses', items: [newObj]})
          // this.$store.commit('addItemToSearch', {item: newObj, firebaseNode: 'LocalBusinesses'})
          this.$store.commit('showAlert', true)
          this.closeEdit()
        } else {
          this.$emit('validation-errors', this.errors)
          alert('Error saving the new LocalBusiness.  Check the form for errors.')
        }
      })
    },
    checkSaveBatchEditFields: function () {
          console.log(this.selectedEntities)
          var self = this
          this.batchEditFieldsApplied.length = 0

          let editObj = this.editLocalBusiness
              _.each(this.batchEditionFields, fKey => {
                  const val = editObj[fKey]
                  if (self.shouldBatchEdit(val, fKey)) {
                    this.batchEditFieldsApplied.push(fKey)
                  }
              })
          if (this.batchEditFieldsApplied.length > 0) {
            this.confirmModal = !this.confirmModal;
          }
    },
    saveBatchEditFields: function () {
      console.log('calling worker')
      var updateArray = {}
      var limit = 5
      var count = 0
      var total = 0
      var self = this
      this.$worker.run((selectedEntities, editLocalBusiness, batchEditionFields, organization, confirmModal) => {
        console.log('jajjaj')
        confirmModal = false

        // db.ref('/LocalBusinesses/' + organization).once('value', snapshot => {
        //   console.log('got the snapshot')
        // })
        // _.each(batchEditionFields, fKey => {
        //     const val = editLocalBusiness[fKey]
        //     if (!isEmpty(val)) {
        //         entity[fKey] = val
        //         updateArray[entity.branchCode + '/' + fKey]  = val
        //     }
        //     count += 1
        //     total += 1
        //     if (count % limit == 0) {
        //       fbLocalBusinessOrg.update(updateArray)
        //       updateArray = {}
        //       count = 0
        //       console.log('processed: ' + total)
        //     }
        // })
        // if (count > 0) {
        //   fbLocalBusinessOrg.update(updateArray)
        // }

      }, [this.selectedEntities, this.editLocalBusiness, this.batchEditionFields, this.$route.params.organization, this.confirmModal]).then(console.log('finished'))
    },

    saveBatchEditFieldsPromise: function() {
      this.showProgress = true
      this.saveBatchEditFieldsOld().then( text => {
         this.showProgress = false
         this.closeEdit()
      })
    },

    saveBatchEditFieldsOld: function () {
      return new Promise((resolve, reject) => {
      console.log(this.selectedEntities)
       var updateArray = {}
       var limit = 500
       var count = 0
       var total = 0
       var selectedTotal = this.selectedEntities.length
      _.each(this.selectedEntities, entity => {
      
          let editObj = this.editLocalBusiness
        
          _.each(this.batchEditionFields, fKey => {
              const val = editObj[fKey]
              if (fKey === 'openingHoursSpecification') {
                if (!isEmpty(this.batchEditDays)) {     
                  this.updateOpeningHoursForBatch(entity)
                  updateArray[entity.branchCode + '/' + fKey]  = entity.openingHoursSpecification
                }
              } else if (fKey === 'specialOpeningHoursSpecification') {
                  if (!isEmpty(this.editLocalBusiness.specialOpeningHoursSpecification) || this.shouldClearAllHolidays) {
                     this.updateSpecialOpeningHoursForBatch(entity)
                     var valObj = {}
                     updateArray[entity.branchCode + '/' + fKey]  = entity.specialOpeningHoursSpecification
                  }
              } else if (this.shouldBatchEdit(val, fKey)) {
                  entity[fKey] = val
                  updateArray[entity.branchCode + '/' + fKey]  = val
              }
          })          
          count += 1
          total += 1
          if (count % limit == 0) {
            this.$firebaseRefs.fbLocalBusinessOrg.update(updateArray)
            updateArray = {}
            count = 0
            console.log('processed: ' + total)
            this.progress = total * 100 / selectedTotal
          }
      })
      console.log(updateArray)
      if (count > 0) {
        this.$firebaseRefs.fbLocalBusinessOrg.update(updateArray)
      }
      this.progress = 100
      this.showProgress = false
      console.log('finished processed: ' + total)
      this.confirmModal = !this.confirmModal;
      this.$store.commit('showAlert', true)
      resolve('finished')
      })
    },
    shouldBatchEdit: function (obj, fieldKey) {
      if (fieldKey === 'openingHoursSpecification') {
        return !isEmpty(this.batchEditDays);
      } else if (fieldKey === 'specialOpeningHoursSpecification') {
        return !isEmpty(this.editLocalBusiness.specialOpeningHoursSpecification) || this.shouldClearAllHolidays;
      } else {
        return !isEmpty(obj)
      }
    },
    toggleBatchField: function (event, field) {
      this.batchEditFields[field] = event
    },
    toggleBatchDay: function(shouldUpdate, day) {
      let dayIdx = this.batchEditDays.indexOf(day)
      if (shouldUpdate && dayIdx === -1) {
        this.batchEditDays.push(day)
      } else if (!shouldUpdate && dayIdx >= 0) {
        this.batchEditDays.splice(dayIdx, 1)
      }
    },
    updateOpeningHoursForBatch: function (entity) {
      var newDays = this.editLocalBusiness.openingHoursSpecification
      var self = this
      if (newDays != null && newDays.length > 0) {
        newDays = newDays.filter(function (value, index, arr) {
          // remove all the day from the newDays from the existing array
          return self.batchEditDays.indexOf(value.dayOfWeek) >= 0
        })
      }
      if (newDays != null && newDays.length >= 0) {
        this.batchEditFieldsApplied.push('openingHoursSpecification')
      }

      var existDays = entity.openingHoursSpecification
      if (existDays != null && existDays.length > 0) {
        existDays = existDays.filter(function (value, index, arr) {
          return self.batchEditDays.indexOf(value.dayOfWeek) === -1
        })
      }
      if (existDays != null) {
        entity.openingHoursSpecification = newDays.concat(existDays)
      }
    },
    updateSpecialOpeningHoursForBatch: function (entity) {
     if (this.shouldClearAllHolidays) {
        entity.specialOpeningHoursSpecification = []
        this.batchEditFieldsApplied.push('specialOpeningHoursSpecification')
      } else if (this.editLocalBusiness.specialOpeningHoursSpecification.length > 0) {
        console.log(this.editLocalBusiness.specialOpeningHoursSpecification)
        this.batchEditFieldsApplied.push('specialOpeningHoursSpecification')
        entity.specialOpeningHoursSpecification = this.editLocalBusiness.specialOpeningHoursSpecification
      }
    },

    closeEdit: function () {
      this.showProgress = false
      this.$router.push({
        name: 'ListLocalBusiness'
      })
    },
    initData: function (data) {
      console.log('INIT DATA')
      this.newEntity = false
      _.assign(this.editLocalBusiness, data);
      console.log(data)
    },
    getAddPropsSpec: function () {
        if (this.$store.getters.organization._additionalPropertiesSpec) {
          return this.$store.getters.organization._additionalPropertiesSpec
        } else {
          return {}
        }
      }
   },
  computed: {
    batchButtonEnabled: function () {
      var self = this
      this.batchEditFieldsApplied.length = 0

      let editObj = this.editLocalBusiness
          _.each(this.batchEditionFields, fKey => {
              const val = editObj[fKey]
              if (self.shouldBatchEdit(val, fKey)) {
                this.batchEditFieldsApplied.push(fKey)
              }
          })
      return this.batchEditFieldsApplied.length > 0
    },
    localBusiness: function () {
      if (this.$route.params.entityId) {
        return this.fbLocalBusiness
      } else {
        return {}
      }
    },
    localBusinessOrg: function () {
      return this.fbLocalBusinessOrg
    },
    dynShowPublishingAlert: function() {
      return this.$store.getters.isPublishingData('pages')
    }
  },
  firebase: function () {
    return {
      fbLocalBusiness:  {
        source: db.ref('/LocalBusinesses/' + this.$route.params.organization + '/' + this.$route.params.entityId),
        asObject: true,
        readyCallback: function (data) {
          console.log('Firebase LocalBusiness Loaded')
          if (this.$route.params.entityId) {
            this.initData(this.fbLocalBusiness)
          }
        }
      },
      fbLocalBusinessOrg:  {
        source: db.ref('/LocalBusinesses/' + this.$route.params.organization),
        asObject: true,
        readyCallback: function (data) {
          console.log('Firebase LocalBusinessOrg Loaded')
          console.log(data)
        }
      }
    }
  }
 }

function isEmpty(obj) {
  if (typeof(obj) == 'undefined' || obj == null) { return true }
  if (typeof(obj) === "string" ) { return obj.length === 0 }
  if (typeof(obj) === "number" ) { return false }
  return Object.keys(obj).length === 0
}

function rndID() {
  return Math.random().toString(36).substr(2).toUpperCase();
}
</script>

<style type="text/css">
.close-modal {
  width: 100%;
  padding: 10px 40px;
}

.close-modal .close {
  font-size: 16px;
}

.edit-location {
  display: block;
  overflow-y: auto;
}

.edit-location-form {}

.edit-location-map-container {
  height: auto;
  width: auto;
  border: 1px solid #FFFFFF;
}

.edit-location-image-upload-row,
.edit-location-address-info,
.edit-location-other-info {
  padding: 1rem;
}

.edit-instructions {
  padding: 20px 40px;
  background-color: #eee;
}

.edit-location-content {
  padding: 40px 0px 40px 0px;
}

.day {
  text-transform: uppercase;
}

.store-hours .dropdown-item a {
  display: block;
}

.store-hours-row {
  margin: 0px;
  padding: 1rem 0px 1rem 0px;
}

.add-hours {
  margin-bottom: 60%;
  margin-left: 5px;
}

.delete-button-margin {
  margin-top: 25px;
}

.store-delete-button-margin {
  margin-top: 18px;
}

.add-button-margin {
  margin-top: 12px;
}

.delete-holiday-button-margin {
  margin-top: 25px;
}

.add-holiday-button-margin {
  margin-top: 12px;
}

.gl-action-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.time-picker input.display-time {
  width: 100%;
  padding: 16px !important;
  font-size: 0.875rem;
  line-height: 1.25;
  color: #333333;
  background-color: #FFF;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  border-radius: 5px !important;
  border: 1px solid #c7c7c7 !important;
  -moz-border-radius: 5px !important;
  -webkit-border-radius: 5px !important;
}

.vdp-datepicker input {
  width: 100%;
  padding: 7px !important;
  font-size: 0.875rem;
  line-height: 1.25;
  color: #333333;
  background-color: #FFF;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  border-radius: 5px !important;
  border: 1px solid #c7c7c7 !important;
  -moz-border-radius: 5px !important;
  -webkit-border-radius: 5px !important;
}

.is-invalid {
  border-color: #f86c6b;
  transition-delay: 0s, 0s;
  transition-duration: 0.15s, 0.15s;
  transition-property: border-color, box-shadow;
  transition-timing-function: ease-in-out, ease-in-out;
}
input.display-time:disabled {
  background-color: #ccc;
}
.v-select .dropdown-toggle {
  border: none;
}
</style>



// WEBPACK FOOTER //
// EditLocalBusiness.vue?51e8d4ed